module.exports = __webpack_public_path__ + "static/media/mp2.de2ec723.svg";